import { SvgIcon, type SvgIconProps } from "@mui/material";

const MastodonIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 96 96">
		<g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
			<path d="M379 949 c-138 -9 -205 -31 -255 -84 -68 -70 -79 -118 -77 -326 4 -345 62 -469 239 -513 85 -22 231 -22 302 -1 50 15 52 17 52 51 l0 34 -42 -7 c-65 -12 -188 -8 -231 6 -45 15 -77 60 -77 107 0 32 0 32 38 23 69 -16 217 -21 301 -10 127 16 222 66 258 134 18 35 33 249 23 334 -19 161 -108 236 -295 249 -38 3 -86 6 -105 7 -19 2 -78 0 -131 -4z m30 -164 c16 -8 38 -27 50 -42 l21 -28 21 28 c61 80 188 75 241 -11 20 -33 23 -52 26 -199 l4 -163 -56 0 -56 0 0 140 c0 136 -1 142 -25 165 -30 31 -37 31 -72 1 -26 -23 -28 -30 -31 -115 l-4 -91 -48 0 -48 0 -4 91 c-3 85 -5 92 -31 115 -35 30 -42 30 -72 -1 -24 -23 -25 -29 -25 -165 l0 -140 -56 0 -56 0 4 163 c3 147 6 166 26 198 38 63 127 88 191 54z" />
		</g>
	</SvgIcon>
);

export default MastodonIcon;
